import { render, staticRenderFns } from "./WithdrawUnpaidFines.vue?vue&type=template&id=48e68af7&"
import script from "./WithdrawUnpaidFines.vue?vue&type=script&lang=js&"
export * from "./WithdrawUnpaidFines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports